export default __webpack_public_path__ + "fonts/Search-icons.svg";